// 日時系を操作するメソッド
// TODO: 他の日時系メソッドをこのファイルに移動させる

import moment from 'moment';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
dayjs.extend(localeData);
dayjs().localeData();

export function basic(date) {
  return moment(date).format('YYYY/MM/DD HH:mm:ss');
}

export function fromNow(value) {
  return moment(value).fromNow();
}

/**
 * date
 * @param date {string|Date}
 * @param format {string|undefined} - If not set format, return "2021-01-01T00:00:00+09:00"
 * @return {string}
 * Unit test
 */
export function formatDate(date, format) {
  /**
   * Return format style by locale
   * @param type {string|undefined}
   * @return {string|undefined}
   */
  const customFormats = (type = undefined) => {
    const collections = {
      en: {
        YtoM: 'MMMM YYYY',
        YtoSec: 'MMMM DD YYYY, h:mm:ss a',
      },
      ja: {
        YtoM: 'YYYY年MM月',
        YtoSec: 'YYYY年MM月DD h:mm:ss',
      },
    };

    if (type === 'YtoM' || type === 'YtoMinute' || type === 'YtoSec') {
      const locale = dayjs.locale();
      return collections[locale][format];
    } else {
      return type;
    }
  };

  if (!date) return undefined;

  if (!dayjs(date).isValid()) return undefined;

  format = customFormats(format);

  return dayjs(date).format(format);
}

// 月の配列から、指定月以降のアイテムのみ取り出す
export function isSameOrAfter(arr, now) {
  /* arr: Array
     now: String
   */
  return arr.filter(val => {
    return moment(moment(val).format('YYYY-MM')).isSameOrAfter(now);
  });
}

/**
 * 日付の配列を作成する。
 * @param start {String | Date}
 * @param end {String | Date}
 * @param type {String} [default: days] Support days/months/etc...
 *    You can use these date types. https://momentjs.com/docs/#/manipulating/add/
 * @param format {String}
 *    You can use these format types. https://momentjs.com/docs/#/displaying/format/
 * @returns {Array}
 *    ['2020/01/01', '2020/01/02',...]
 */
export const generateDateArray = (start, end, type = 'days', format) => {
  if (!start || !end) return [];

  const formatStyle = () => {
    if (type === 'days') {
      if (!format) {
        return 'YYYY-MM-DD';
      }
      return format;
    }

    if (type === 'months') {
      if (!format) {
        return 'YYYY-MM';
      }
      return format;
    }

    if (type === 'years') {
      if (!format) {
        return 'YYYY';
      }
      return format;
    }
  };

  const startDate = moment(start);
  const endDate = moment(end);

  const diff = endDate.diff(startDate, type);

  const dates = [];
  for (let i = 0; i <= diff; i++) {
    const date = moment(startDate)
      .add(i, type)
      .format(formatStyle(format));
    dates.push(date);
  }

  return dates;
};

export const getMonths = () => {
  return dayjs.monthsShort().map((month, i) => ({
    label: month,
    value: dayjs()
      .month(i)
      .format('MM'),
  }));
};
